export default {
  tone: {
    value: [
      'v5:formal',
      'v5:informal',
      'v5:humorous',
      'v5:assertive',
      'v5:sarcastic',
      'v5:optimistic'
    ],
    description: 'v5:story_description_tone'
  },
  narrativeHook: {
    isOptional: true,
    value: '',
    description: 'v5:story_description_narrative_hook'
  },
  narrativeStyle: {
    value: [
      'v5:firstPerson',
      'v5:secondPerson',
      'v5:thirdPersonLimited',
      'v5:thirdPersonOmniscient',
      'v5:epistolary'
    ],
    description: 'v5:story_description_narrative_style'
  },
  storyPlot: {
    isOptional: true,
    value: '',
    description: 'v5:story_description_story_plot'
  },
  complexity: {
    value: ['v5:beginner', 'v5:intermediate', 'v5:advanced', 'v5:experimental'],
    description: 'v5:story_description_complexity'
  },
  genre: {
    value: [
      'v5:realistic',
      'v5:historical',
      'v5:casual',
      'v5:drama',
      'v5:fantasy',
      'v5:adventure',
      'v5:satire',
      'v5:scienceFiction',
      'v5:mystery'
    ],
    description: 'v5:story_description_genre'
  },
  vocabulary: {
    value: [
      'v5:simple',
      'v5:moderate',
      'v5:advanced',
      'v5:jargonOrTechnical',
      'v5:periodSpecific',
      'v5:slangOrColloquial'
    ],
    description: 'v5:story_description_vocabulary'
  },
  narrativeStructure: {
    value: [
      'v5:linear',
      'v5:nonLinear',
      'v5:circular',
      'v5:inMediaRes',
      'v5:framedNarrative'
    ],
    description: 'v5:story_description_narrative_structure'
  },
  timePeriod: {
    value: ['v5:past', 'v5:present', 'v5:future', 'v5:timelessOrUnspecified'],
    description: 'v5:story_description_time_period'
  },
  storyLength: {
    value: ['v5:short', 'v5:medium', 'v5:long'],
    description: 'v5:story_description_story_length'
  },
  characterNames: {
    value: [],
    description: 'v5:story_description_character_names'
  },
  outputType: {
    value: ['v5:screenplay', 'v5:narrative'],
    description: 'v5:story_description_output_type'
  }
}
